import Super from './base.gjs';

export default class SpdsLayoutFlexRow extends Super {
  column = false;
  variantClass = 'spds-layout-flex-row';
}
